;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout = APP.module('Layout');

	Layout.Footer = Layout.Footer.extend({
		template: JST.AflClubsFooter,
		init_ad: function () {
			return this;
		},
		onRender: function() {

			this.init_ad();

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));